import 'reflect-metadata';
import { injectable, inject } from 'inversify';
import Client from '@dealroadshow/socket-frontend-sdk';
import JsonRpcDispatcher from '@dealroadshow/json-rpc-dispatcher';
import DITypes from './DI/types';

@injectable()
export default class SocketClient extends Client {
  constructor(
    @inject(DITypes.SocketDispatcher) dispatcher: JsonRpcDispatcher,
  ) {
    super(dispatcher);
  }
}
